import { Link } from "react-router-dom";
import { 
  Cloud, 
  Shield, 
  Monitor, 
  HardDrive, 
  Laptop, 
  Wifi, 
  Globe, 
  Mail,
  ArrowRight
} from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const services = [
  {
    icon: Mail,
    title: "Microsoft 365",
    description: "Full Microsoft 365 setup, migration, and ongoing management to boost your team's productivity.",
    features: ["Email & Calendar", "Teams Collaboration", "SharePoint", "OneDrive"],
  },
  {
    icon: Monitor,
    title: "IT Support",
    description: "Reliable, responsive IT support for businesses of all sizes. We're your dedicated IT department.",
    features: ["Helpdesk Support", "Remote Assistance", "On-site Visits", "Proactive Monitoring"],
  },
  {
    icon: Cloud,
    title: "Cloud Services",
    description: "Secure and scalable cloud solutions that grow with your business needs.",
    features: ["Cloud Migration", "Azure Services", "Hybrid Solutions", "Cloud Management"],
  },
  {
    icon: HardDrive,
    title: "Backup Solutions",
    description: "Comprehensive backup and disaster recovery to protect your critical business data.",
    features: ["Automated Backups", "Offsite Storage", "Disaster Recovery", "Data Restoration"],
  },
  {
    icon: Shield,
    title: "Cyber Security",
    description: "Protect your business from cyber threats with our comprehensive security solutions.",
    features: ["Threat Detection", "Firewall Management", "Security Training", "Compliance"],
  },
  {
    icon: Laptop,
    title: "Remote Working",
    description: "Enable your team to work securely from anywhere with our remote working solutions.",
    features: ["VPN Setup", "Remote Desktop", "Collaboration Tools", "Security Policies"],
  },
  {
    icon: Wifi,
    title: "Broadband",
    description: "Business-grade broadband solutions with guaranteed speeds and reliability.",
    features: ["Fibre Broadband", "Leased Lines", "Network Setup", "WiFi Solutions"],
  },
  {
    icon: Globe,
    title: "Website Design",
    description: "Professional, responsive websites that represent your business online.",
    features: ["Custom Design", "Responsive", "SEO Optimised", "Hosting & Maintenance"],
  },
];

const Services = () => {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Our Services
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Comprehensive IT solutions tailored for Swansea businesses. From cloud services to cyber security, we've got you covered.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <Card 
              key={service.title} 
              className="group hover:shadow-elevated transition-all duration-300 border-border hover:border-primary/30"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <CardHeader>
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary group-hover:shadow-glow transition-all duration-300">
                  <service.icon className="h-6 w-6 text-primary group-hover:text-primary-foreground transition-colors" />
                </div>
                <CardTitle className="text-lg">{service.title}</CardTitle>
                <CardDescription className="text-sm">
                  {service.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {service.features.map((feature) => (
                    <li key={feature} className="text-sm text-muted-foreground flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button asChild size="lg">
            <Link to="/services">
              View All Services
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Services;
